import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={16} fill="none" {...props}>
    <path fill="#B2B2B2" d="M15.75 5.333C15.75 2.388 13.4 0 10.5 0S5.25 2.388 5.25 5.333C2.35 5.333 0 7.721 0 10.667V16h21v-4c0-2.946-2.35-5.333-5.25-5.333z" />
  </svg>
);
export default SvgCloud;
